export default __webpack_public_path__ + "files/FP10_Blended_Finance.docx";